import Image, { StaticImageData } from "next/image";
import { getAvailableGrades } from "../../helpers";
import comet from "../../public/assets/onboarding/comet.svg";
import gulu from "../../public/assets/onboarding/gulu.svg";
import mars from "../../public/assets/onboarding/mars.svg";
import controlRoom from "../../public/assets/onboarding/control_room.svg";
import { useFormContext } from "react-hook-form";
import { forwardRef, useContext, useImperativeHandle } from "react";
import { BoardingFlowContext } from "../../context/auth/BoardingFlowContext";
import { useBoardingFlow } from "../../hooks/useBoardingFlow";
import useIsProduction from "../../hooks/isProduction";

interface AvailableGradeMap {
  grade: string;
  value: string;
  planet: StaticImageData | string;
  standard: boolean;
  enableToSelect: boolean;
  isProduction: boolean;
}

function IStudyInStep(props, ref) {
  const { setValue, getValues, watch } = useFormContext();
  const [, setActiveTab] = useContext(BoardingFlowContext).activeTab;
  const { setUserGradeAndName } = useBoardingFlow();
  const isProduction = useIsProduction();

  const selectedGrade = watch("grade");

  const setUserGrade = (value: string) => {
    // By the time user reaches to this screen, we can assume that the user's name is set in the form context
    setValue("grade", value);
    const userHasName = Boolean(getValues("name"));
    if (!userHasName) {
      return setActiveTab(4);
    }
    // This setter will read the required values from the form context
    // So before calling this, we should ensure that the context is set with the required values
    setUserGradeAndName();
  };

  useImperativeHandle(ref, () => ({
    reset: () => {
      setValue("grade", null);
    },
  }));

  return (
    <div className="slide__page">
      <div className="fourth__page__inner">
        <div className="stars__background">
          <div className="stars"></div>
          <div className="twinkling"></div>
        </div>

        <div className="top__area">
          <h6>I study in</h6>
        </div>
        <div className="select__classes">
          {(getAvailableGrades(null, true, isProduction) as any).map(
            (gradeMap: AvailableGradeMap) => (
              <div
                key={gradeMap.grade}
                className={
                  "class__item" +
                  ((isProduction ? gradeMap.enableToSelect : true)
                    ? ""
                    : " disabled") +
                  (selectedGrade === gradeMap.value
                    ? " active"
                    : selectedGrade
                    ? " not-active"
                    : "")
                }
                onClick={() => setUserGrade(gradeMap.value)}
              >
                <Image
                  height={100}
                  width={100}
                  src={gradeMap.planet}
                  alt="planet2"
                  draggable={false}
                />
                <h6>{gradeMap.grade}</h6>
              </div>
            )
          )}
          {/*[*/}
          {/*// { planet: planet1, grade: "Class 2", value: "class_2" },*/}
          {/*{ planet: planet4, grade: "Class 9", value: "class_9" },*/}
          {/*{ planet: planet6, grade: "Class 10", value: "class_10" },*/}
          {/*]*/}
        </div>

        <Image
          height={100}
          width={100}
          src={comet}
          alt="comet"
          className="comet"
        />
        <Image
          height={100}
          width={100}
          src={comet}
          alt="comet2"
          className="comet2"
        />

        <Image
          height={100}
          width={100}
          src={gulu}
          alt="gulu"
          className="gulu"
          draggable={false}
        />
        <Image
          height={100}
          width={100}
          src={mars}
          alt="mars"
          className="mars"
          draggable={false}
        />
        <Image
          height={100}
          width={100}
          src={controlRoom}
          alt="control"
          className="control"
          draggable={false}
        />
      </div>
    </div>
  );
}

export default forwardRef(IStudyInStep);
